import { useEffect, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";
import Hero from "./components/Hero";
import DataContext from "./contexts/DataContext";
import canidateInfo from "./api/candidateInfo";
import axios from "./api/axios";
import formStart from "./api/formStart";
import { Tabs } from "./components/Tabs";
import { BasicDataTab } from "./components/BasicDataTab";
import { SubmitButton } from "./components/SubmitButton";
import { environment } from "./global/environment";
import { StudiesDataTab } from "./components/StudiesDataTab";
import { JobExperienceDataTab } from "./components/JobExperienceDataTab";
import { CurriculumVitaeDataTab } from "./components/CurriculumVitaeDataTab";
import { MyApplicationsTab } from "./components/MyApplicationsTab";
import jsonToFormData from "./utils/jsonToFormData";
import processInterstAreas from "./utils/processInterstAreas";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './assets/css/style.css';
import candidateInfo from "./api/candidateInfo";

function App() {
  const methods = useForm({ defaultValues: formStart });
  const [candidate, setCandidate] = useState(canidateInfo ?? {});
  const [isInternalUser, setIsInternalUser] = useState(window.isInternalUser);
  // El colaborador interno no ve "Datos básicos", así que arranca en "Mis postulaciones"
  const [currentTab, setCurrentTab] = useState(window.isInternalUser ? 5 : 1);
  const [loading, setLoading] = useState(false);

  const contextValue = {
    candidate,
    currentTab,
    setCandidate,
    setCurrentTab,
  };

  useEffect(() => {
    //Check ignore cases
    if(isInternalUser) return;
    if(currentTab === 1 && (!candidate.ethnicOrigin || !candidate.sex || !candidate.originCountry)) return;
    if(currentTab === 4 && (!candidate.employmentStatus)) return;

    //Check reaction cases
    if(!candidate.ethnicOrigin || !candidate.sex || !candidate.originCountry){
      setCurrentTab(1);
      return;
    }

    if(!candidate.employmentStatus){
      setCurrentTab(4);
      return;
    }

  }, [candidate]);

  //On submit form
  const onSubmit = (data) => {
    //Start loading
    setLoading(true);

    if (data.willingToRelocateInfoNew) data.willingToRelocateInfo = data.willingToRelocateInfoNew.toString();
    if (data.languages) data.languages = JSON.stringify(data.languages);
    // if (!data.cv) delete data.cv;
    // if (!data.cvName) delete data.cvName;
    if (data.driversCardNew) data.driversCard = data.driversCardNew.toString();
    if (data.location) data.location = JSON.stringify(data.location);
    if (data.document) data.document = JSON.stringify(data.document);

    // if (data.location) data.location = JSON.stringify(data.location);
    data.jobExperiences?.map((jobExperience) => {
      return (
        jobExperience.jobReferencesData = JSON.stringify(jobExperience.jobReferencesData),
        jobExperience.location = JSON.stringify(jobExperience.location))
    })

    data.interestAreas = processInterstAreas(data, candidate);

    //Remove document when documentType and documentNumber are present
    if(data.documentType || data.documentNumber){
      data.document = null;
    }

    //Do put
    axios.put(environment.candidateUri + candidate.id, jsonToFormData(data)).then(
      (response) => {
        //Stop loading
        setLoading(false);
        setCandidate(response.data);

        //Show toasts
        toast.success('Se guardó correctamente el perfil.', {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          });
      },
      (responseJSON) => {
        //Stop loading
        setLoading(false);

        //Show error
        toast.error('Ocurrió un error al guardar el perfil.', {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        //Check 401
        if(responseJSON?.response?.status === 401){
          window.location.href = environment.logoutURL;
        }
      }
    );
  };

  return (
    <DataContext.Provider value={contextValue}>
      <FormProvider {...methods}>
        <Hero />
        <main>
          <div className="c-profile-info">
            <div className="c-profile-info__holder">
              <Tabs onSubmit={methods.handleSubmit(onSubmit)} errors={methods.formState.errors} isValid={methods.trigger} />

              <div className="c-profile-info__viewport">
                <form className="c-form" onSubmit={methods.handleSubmit(onSubmit)}>
                  {currentTab === 1 && !isInternalUser && <BasicDataTab candidateId={candidate.id} candidateInfo={candidateInfo} />}
                  {currentTab === 2 && <StudiesDataTab />}
                  {currentTab === 3 && <JobExperienceDataTab />}
                  {currentTab === 4 && <CurriculumVitaeDataTab />}
                  {currentTab === 5 && <MyApplicationsTab />} 
                  <SubmitButton loading={loading} />
                  <ToastContainer
                    position="bottom-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                  />
                </form>
              </div>
            </div>
          </div>
        </main>
      </FormProvider>
    </DataContext.Provider>
  );
}

export default App;
